/**
 * Safe wrappers around localStorage to prevent crashes from corrupt data.
 * Every function catches and logs errors instead of throwing.
 */

export function safeGet(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw);
  } catch (err) {
    console.warn(`[safeStorage] Corrupt value for key "${key}", using fallback.`, err);
    localStorage.removeItem(key);
    return fallback;
  }
}

export function safeSet(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (err) {
    console.warn(`[safeStorage] Failed to write key "${key}".`, err);
    return false;
  }
}

export function safeRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.warn(`[safeStorage] Failed to remove key "${key}".`, err);
  }
}
